import FinanceNav from "../../pages/Dashboard/Finance/FinanceNav";
import FinanceIndex from "../../pages/Dashboard/Finance/FinanceIndex";
import { Navigate } from "react-router-dom";
import FeesCollection from "../../pages/Dashboard/Finance/FeesCollection/FeesCollection";
import PatientsInFinance from "../../pages/Dashboard/Finance/Patients/Patients";
import ManageExpensesType from "../../pages/Dashboard/Finance/expensesType/ManageExpensesType";
import ListExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/ListExpenseSource/ListExpenseSource";
import AddExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/AddExpenseSource/AddExpenseSource";
import ExpensesList from "../../pages/Dashboard/Finance/Expenses/ExpensesList";
import Expenses from "../../pages/Dashboard/Finance/Expenses/Expenses";
import ExpensePaymentList from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePaymentList";
import ExpensePayment from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePayment";
import ApprovePurchase from "../../pages/Dashboard/Finance/ApprovePurchase/ApprovePurchase";
import Report from "../../pages/Dashboard/Finance/Report/Report";
import CollectByTicket from "../../pages/Dashboard/Reception/CollectByTicket/CollectByTicket";
import CollectDentalFees from "../../pages/Dashboard/Reception/CollectDentalFees/CollectDentalFees";
import CollectDentalFeesList from "../../pages/Dashboard/Reception/CollectDentalFees/CollectDentalFeesList";
import CollectBeautyFees from "../../pages/Dashboard/Reception/CollectBeautyFees/CollectBeautyFees";
import CollectBeautyFeesList from "../../pages/Dashboard/Reception/CollectBeautyFees/CollectBeautyFeesList";
import CollectHtPatientFees from "../../pages/Dashboard/Reception/CollectHtPatientFees/CollectHtPatientFees";
import CollectHtPatientFeesList from "../../pages/Dashboard/Reception/CollectHtPatientFees/CollectHtPatientFeesList";
import UltrasoundCollectFees from "../../pages/Dashboard/Reception/ultrasoundCollectFees/UltrasoundCollectFees";
import UltrasoundReferral from "../../pages/Dashboard/Reception/ultrasoundCollectFees/UltrasoundReferral";
import XrayCollectFees from "../../pages/Dashboard/Reception/xrayCollectFees/XrayCollectFees";
import XRayReferral from "../../pages/Dashboard/Reception/xrayCollectFees/XRayReferral";
import LaboratoryCollectFees from "../../pages/Dashboard/Reception/laboratoryCollectFees/LaboratoryCollectFees";
import EchoCollectFees from "../../pages/Dashboard/Reception/echoCollectFees/EchoCollectFees";
import EchoReferral from "../../pages/Dashboard/Reception/echoCollectFees/EchoReferral";
import CollectEmergencyFees from "../../pages/Dashboard/Reception/CollectEmergencyFees/CollectEmergencyFees";
import CollectIPDFees from "../../pages/Dashboard/Reception/collectIPDFees/CollectIPDFees";
import CollectICUFees from "../../pages/Dashboard/Reception/collectICUFees/CollectICUFees";
import CollectNICUFees from "../../pages/Dashboard/Finance/FeesCollection/NICUFees/CollectNICUFees";
import AmbulanceFees from "../../pages/Dashboard/Finance/FeesCollection/AmbulanceFees/AmbulanceFees";
import AmbulancePatientPaymentForm from "../../pages/Dashboard/Finance/FeesCollection/AmbulanceFees/AmbulancePatientPaymentForm";
import AmbulanceDriverPaymentForm from "../../pages/Dashboard/Finance/FeesCollection/AmbulanceFees/AmbulanceDriverPaymentForm";

const financeRoutes = {
  path: "/finance",
  element: <FinanceNav />,
  children: [
    { path: "/finance", element: <FinanceIndex /> },
    { path: "/finance/fees-collection", element: <FeesCollection /> },
    { path: "/finance/payment-collection", element: <CollectByTicket /> },
    { path: "/finance/collect-prescription-fees", element: <CollectByTicket /> },
    { path: "/finance/collect-medicine-order-fees", element: <CollectByTicket /> },
    { path: "/finance/fees-collection/dental", element: <CollectDentalFeesList /> },
    { path: "/finance/fees-collection/dental/add", element: <CollectDentalFees /> },
    { path: "/finance/fees-collection/beauty", element: <CollectBeautyFeesList /> },
    { path: "/finance/fees-collection/beauty/add", element: <CollectBeautyFees /> },
    { path: "/finance/fees-collection/ht-patient", element: <CollectHtPatientFeesList /> },
    { path: "/finance/fees-collection/ht-patient/add", element: <CollectHtPatientFees /> },
    { path: "/finance/fees-collection/ultrasound", element: <UltrasoundCollectFees /> },
    { path: "/finance/fees-collection/ultrasound/add", element: <UltrasoundReferral /> },
    { path: "/finance/fees-collection/xray", element: <XrayCollectFees /> },
    { path: "/finance/fees-collection/xray/add", element: <XRayReferral /> },
    { path: "/finance/fees-collection/laboratory", element: <LaboratoryCollectFees /> },
    { path: "/finance/fees-collection/echo", element: <EchoCollectFees /> },
    { path: "/finance/fees-collection/echo/add", element: <EchoReferral /> },
    { path: "/finance/fees-collection/emergency", element: <CollectEmergencyFees /> },
    { path: "/finance/fees-collection/ipd", element: <CollectIPDFees /> },
    { path: "/finance/fees-collection/icu", element: <CollectICUFees /> },
    { path: "/finance/fees-collection/nicu", element: <CollectNICUFees /> },
    { path: "/finance/fees-collection/ambulance", element: <AmbulanceFees /> },
    { path: "/finance/fees-collection/ambulance/patient/add", element: <AmbulancePatientPaymentForm /> },
    { path: "/finance/fees-collection/ambulance/driver/add", element: <AmbulanceDriverPaymentForm /> },
    { path: "/finance/patients", element: <PatientsInFinance /> },
    { path: "/finance/expenses-type", element: <ManageExpensesType /> },
    { path: "/finance/expense-source", element: <ListExpenseSource /> },
    { path: "/finance/expense-source/add", element: <AddExpenseSource /> },
    { path: "/finance/expenses", element: <ExpensesList /> },
    { path: "/finance/expenses/add", element: <Expenses /> },
    { path: "/finance/expense-payments", element: <ExpensePaymentList /> },
    { path: "/finance/expense-payments/add", element: <ExpensePayment /> },
    {
      path: "/finance/payroll",
      element: <Navigate to="/financial-manager/payroll" replace />,
    },
    {
      path: "/finance/advance",
      element: <Navigate to="/financial-manager/advance" replace />,
    },
    {
      path: "/finance/bonus",
      element: <Navigate to="/financial-manager/bonus" replace />,
    },
    { path: "/finance/approve", element: <ApprovePurchase /> },
    {
      path: "/finance/medicine-payment",
      element: <Navigate to="/financial-manager/medicine-payment" replace />,
    },
    {
      path: "/finance/medicine-payment/add",
      element: <Navigate to="/financial-manager/medicine-payment/add" replace />,
    },
    {
      path: "/finance/invoices",
      element: <Navigate to="/financial-manager/invoices" replace />,
    },
    {
      path: "/finance/invoices/add",
      element: <Navigate to="/financial-manager/invoices/add" replace />,
    },
    {
      path: "/finance/invoices/:id",
      element: <Navigate to="/financial-manager/invoices" replace />,
    },
    {
      path: "/finance/payments",
      element: <Navigate to="/financial-manager/payments" replace />,
    },
    {
      path: "/finance/payments/add",
      element: <Navigate to="/financial-manager/payments/add" replace />,
    },
    { path: "/finance/report", element: <Report /> },
  ],
};

export default financeRoutes;
